import { Component, OnInit, Input } from '@angular/core';
import { IDetailDocument } from '../dashboard.service';
import { Router } from '@angular/router';
import { AppRoutingService } from '../../shared/app-routing.service';
import { DatePipe } from '@angular/common';
import { FocusMeDirective } from '../../shared/focus.directive';

@Component({
    selector: 'app-document-callout',
    templateUrl: './document-callout.component.html',
    styleUrls: ['./document-callout.component.scss'],
    standalone: true,
    imports: [FocusMeDirective, DatePipe]
})
export class DocumentCalloutComponent implements OnInit {

  @Input() detaildocument: IDetailDocument;
  constructor(private router: Router, private appRoutingService: AppRoutingService) { }

  ngOnInit() {

  }

  navigateToDetailZitting() {
    this.router.navigate(['/detailzitting', this.detaildocument.ZittingId]);
    return false;
  }

  navigateToDetail() {
    if (this.detaildocument.PuntId) {
      this.appRoutingService.navigateToDetailPunt(this.detaildocument.ZittingId, this.detaildocument.PuntId);
    } else {
      this.navigateToDetailZitting();
    }
    return false;
  }

}
